import React from "react";
import Header from '../_part/Header';
import '../_css/etc.css'

import { Link } from "react-router-dom";


function Comment(num, title, path, date){
    return(     
        <tr>
            <td style={{textAlign:"center"}}>{num}</td>
            <td><Link to={path}>{title}</Link></td>
            <td style={{textAlign:"center"}}>{date}</td>
        </tr>
    );
}



function ETC(){
    return(
        <div>
            <div className="etc_body">
                <table>
                    <tr>
                        <th style={{width:"3%"}}>No</th>
                        <th>title</th>
                        <th style={{width:"20%"}}>date</th>
                    </tr>

                    {Comment(1, "making", "/ETC/making", "2024.11.25")}
                    {Comment(2, "2", "", "???")}
                    {Comment("?", "???", "", "???")}
                    {Comment("?", "???", "", "???")}
                    {Comment("?", "???", "", "???")}
                    {Comment("?", "???", "", "???")}
                    {Comment("?", "???", "", "???")}
                    {Comment("?", "???", "", "???")}
                    {Comment("?", "???", "", "???")}
                    {Comment("?", "???", "", "???")}
                    {Comment("?", "???", "", "???")}
                    {Comment("?", "???", "", "???")}
                </table>

                <div style={{paddingTop:"100%"}}></div>
            </div>
            
            
            <Header />
        </div>
    );
}

export default ETC;
